<template>
  <table class="table table-hover bg-white">
    <template v-for="(stats, client_id) in statsClient">
      <!-- <div class="row float-left">
        </div> -->
      <tbody :key="client_id + 2" :id="'collapseLocation' + client_id" class=""
        :aria-labelledby="'collapseLocation' + client_id" data-parent="#accordionlocation">
        <tr :key="client_id + 'header'" class="font-weight-bold" v-if="statsDate.length > 1 || thisMonth">
          <td width="160px"></td>
          <td width="120px" v-for="date in statsDate" :key="client_id + date.date" class="text-right">
            <b>{{ date.date }}</b>
          </td>
          <td class="text-right" v-if="statsDate.length > 1">Total</td>
        </tr>
        <template v-if="!onlyTotal">
          <tr v-for="(type, i) in statsType.filter(e => !e.includes('total'))" :key="type">
            <td v-if="!thisMonth && statsTypeText.length === 0">
              <b>{{ type }}</b>
            </td>
            <td v-else>
              <b>{{ statsTypeText[i] }}</b>
            </td>

            <td v-for="(date, index) in statsDate" :key="client_id + type + date.date" class="text-right">
              <span v-if="
                    stats[date.date] != undefined
                  ">
                <div v-if="thisMonth">
                  <span class="small mr-2">{{ stats[date.date][type] }}
                    <span v-if="type != 'adjusted_comission'">%</span>
                    <span v-if="type == 'adjusted_comission'">€</span>
                  </span>
                  <span class="d-inline" v-if="type != 'adjusted_comission' && type != 'total_objective' ">({{
                    stats[date.date][type + "_amount"] }})</span>
                </div>
                <div v-else>
                  <span class="d-inline mr-1">€</span> <span class="d-inline">{{ getPrice(stats[date.date][type +
                    "_amount"]) }}</span>
                  <span class="d-inline mr-1"></span>
                  <span class="d-inline" v-if="hasPermissions('superAdmin')"
                    :class="{'text-secondary': getPercentagePrice(stats[date.date][type + '_amount'], index, date.date, type, stats) === 'equal',
                        'text-danger': getPercentagePrice(stats[date.date][type + '_amount'], index, date.date, type, stats) === 'less',
                        'text-success': getPercentagePrice(stats[date.date][type + '_amount'], index, date.date, type, stats) === 'greater'}">{{
                    getPercentagePrice(stats[date.date][type + "_amount_percentage"],null,null,type) }}</span>
                  <span class="badge ml-2" :class="type.includes('subscription') ? 'badge-warning' : 'badge-secondary'"
                    v-if=" stats[date.date][type]> 0"> {{ stats[date.date][type] }} </span>
                </div>
              </span>
              <span v-else>-</span>
            </td>
            <td class="text-right font-weight-bold" v-if="statsDate.length > 1">
              <!-- Columna Totales -->
              <span class="d-inline">€</span>
              <span class="d-inline">
                {{ getPrice(stats[type + "_amount"], stats, showTotal) }}
              </span>
            </td>
          </tr>

          <tr class="font-weight-bold" v-if="statsDate.length > 1 && showTotal.subtotal">
            <td><b>{{ showSubtotal }}</b></td>
            <td v-for="(date, index) in statsDate" :key="client_id + date.date" class="text-right">
              <span class="d-inline mr-1">€</span> <span class="d-inline">{{ getSubtotal(date.date, stats,
                showTotal.item) }}</span>

              <span class="d-inline" v-if="showTotal.item != 'Charged'" :class="{'text-secondary': getPercentage(date.date, stats, showTotal.item, index) === 'equal',
                        'text-danger': getPercentage(date.date, stats, showTotal.item, index) === 'less',
                        'text-success': getPercentage(date.date, stats, showTotal.item, index) === 'greater'}">
                <span v-if="hasPermissions('superAdmin')">{{ getPercentage(date.date, stats, showTotal.item) }}</span>
              </span>

            </td>

            <!-- Suma de subtotales -->
            <td class="text-right">
              <span class="d-inline mr-1">€</span> <span class="d-inline">{{ getFullTotal(stats) }}</span>
            </td>
          </tr>
        </template>
        <tr class="font-weight-bold" v-if="statsDate.length > 1 && showTotal.total">
          <td><b>{{ showDataTotal }}</b></td>

          <td v-for="(date, index) in statsDate" :key="client_id + date.date" class="text-right">
            <!-- <span>
                <span class="small" v-if="!onlyTotal"
                  >({{ getTotalQty(date.date, stats) }})</span
                >
              </span> -->
            <span class="d-inline">€</span>
            <span v-if="showTotal.total" class="d-inline">
              {{ getTotalCustom(date.date, stats, showTotal.item) }}
            </span>
            <!-- <span class="d-inline mr-1"></span> <span class="d-inline"
                :class="{'text-secondary': getPercentageTotal(date.date, stats, showTotal.item, index) === 'equal',
                        'text-danger': getPercentageTotal(date.date, stats, showTotal.item, index) === 'less',
                        'text-success': getPercentageTotal(date.date, stats, showTotal.item, index) === 'greater'}"
              >
                {{  getPercentageTotal(date.date, stats, showTotal.item) }}
              </span> -->
          </td>
          <td class="text-right">
            <span class="d-inline mr-1">€</span>
            <span class="d-inline">{{ getSumTotals(stats, statsType) }}</span>
          </td>
        </tr>
      </tbody>
    </template>
  </table>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { statusBadgeMixin, urlMixin, logoMixin } from "@/_mixins/";
import { billingsService, clientsService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default {
  props: {
    // stats: {
    //   type: Object,
    //   required: true,
    // },
    statsClient: {
      type: Object,
      required: true,
    },
    statsType: {
      type: Array,
      required: true,
    },
    statsDate: {
      type: Array,
      required: true,
    },
    onlyTotal: {
      type: Boolean,
      onlyTotal: false,
    },
    thisMonth: {
      type: Boolean,
      default: false,
    },
    statsTypeText:{
      type: Array,
      default: () => []
    },
    showTotal:{
      type: Object,
      default: () => {
        return { item: null, subtotal:false, total:false }
      }
    },
  },
  data() {
    return {
      fee: 0.1, // antes 20% > ahora 35% > ahora 10% // agency commission 10%
      totalColumns: 0
    };
  },

  components: {
    LoadingSpinner,
  },

  computed: {
    showSubtotal(){
      return this.statsTypeText.filter( e => e.includes('Sub-total'))[0]
    },
    showDataTotal(){
      return this.statsTypeText.filter( e => e.includes('Total'))[0]
    }
  },

  created() {
      if(this.hasPermissions('isReferal')){
        this.fee = 0.1
      }else{
        this.fee = 0.1 // agency commission 10%
      }
    },


  methods: {
    getPrice(amount, stats = null, type = null) {
      if(this.hasPermissions('isAgencyManager')){
        return parseFloat(amount*this.fee).toFixed(2)
      }
      if(stats){
        if(type && type.item === 'Charged'){
          const getFullTotal = ((parseFloat(amount).toFixed(0) / this.getFullTotal(stats)) * 100).toFixed(2).toString();
          return parseFloat(amount).toFixed(0).toString() + ' ' + '(' + getFullTotal + ')';
        } else {
          const getFullTotal = ((parseFloat(amount).toFixed(0) / this.getSumTotals(stats, this.statsType)) * 100).toFixed(2).toString();
          return parseFloat(amount).toFixed(0).toString() + ' ' + '(' + getFullTotal + ')';
        }
      }
      return parseFloat(amount).toFixed(0);
    },

    getPercentagePrice(amount, index = null, date = null, type = null, stats = null) {

      if(this.hasPermissions('isAgencyManager')){
        return '(' + parseFloat(amount*this.fee).toFixed(2) + ')';
      }

      if(index && index > 0) {
        const datePrevious = this.statsDate[index - 1].date;
        const amountPrevious = stats[datePrevious][type + "_amount_percentage"];
        const amountCurrent = stats[date][type + "_amount_percentage"];
        if(amountCurrent < amountPrevious ){
            return 'less';
          } else {
            if(amountCurrent == amountPrevious ){
              return 'equal';
            } else {
              return 'greater';
            }
          }

      } else {
        if(isNaN(amount)){
          
          return (type && type === 'vat') ? "" : '(0.0)';
        } else {
          return '(' + amount + ')';
        }

      }
    },
    getTotal(date, stats) {
      let total = 0;
      this.statsType.forEach((type) => {
        if (stats[date][type + "_amount"] != undefined) {
          total += parseFloat(stats[date][type + "_amount"]);
        }
      });
      if(this.hasPermissions('isAgencyManager')){
        return parseFloat(total*this.fee).toFixed(2)

      }
      return parseFloat(total).toFixed(2);
    },
    getTotalCustom( date, stats, item ){
      return parseInt(stats[date]['total' + item ])
    },
    getSubtotal(date, stats, item) {
      return stats[date]['subtotal' + item ]
    },

    getPercentage(date, stats, item, index = null) {
        if(index && index > 0) {
          const datePrevious = this.statsDate[index - 1].date;
          const amountPrevious = stats[datePrevious]['percentage' + item ];
          const amountCurrent = stats[date]['percentage' + item ];

          //if(amountCurrent < amountPrevious ){
          if (Math.round(amountCurrent * 10) / 10 < Math.round(amountPrevious * 10) / 10) {
            return 'less';
          } else {
            if(amountCurrent == amountPrevious ){
              return 'equal';
            } else {
              return 'greater';
            }
          }
        } else {
          return (stats[date]['percentage' + item ] != 'NaN' || stats[date]['percentage' + item ] == '0.0') ? '(' + stats[date]['percentage' + item ] + ')' : '0.0';
        }
    },

    getPercentageTotal(date, stats, item, index = null) {
      if(item != 'Charged'){
        if(index && index > 0) {
          const datePrevious = this.statsDate[index - 1].date;

          const amountPrevious = stats[datePrevious]['percentageTotal' + item ];
          const amountCurrent = stats[date]['percentageTotal' + item ];

          if (Math.round(amountCurrent * 10) / 10 < Math.round(amountPrevious * 10) / 10) {
            return 'less';
          } else {
            if(amountCurrent == amountPrevious ){
              return 'equal';
            } else {

              return 'greater';
            }
          }
        } else {
          return '(' + stats[date]['percentageTotal' + item ] + ')';

        }
      }
    },

    getTotalQty(date, stats) {
      let total = 0;
      this.statsType.forEach((type) => {
        if (stats[date][type] != undefined) {
          total += parseFloat(stats[date][type]);
        }
      });
      return parseFloat(total).toFixed(0);
    },

    getSumTotals(stats, type){
      let total = 0;
      for (const key in stats) {
        if (typeof stats[key] === 'object' && key !== 'name') {
          if(type.includes('uncharged')){
            total = total + parseInt(stats[key].totalUncharged)
          }

          if(type.includes('planned')){
            total = total + parseInt(stats[key].totalPlanned)
          }

          if(type.includes('declined')){
            total = total + parseInt(stats[key].totalDeclined)
          }

          if(type.includes('absent')){
            total = total + parseInt(stats[key].totalAbsent)
          }

        } else {
          //console.log(`${key}: ${stats[key]}`);
        }
      }
      return total;
    },
    getFullTotal(stats) {
      let total = 0;
      let percentage = 0;
      this.statsType.forEach((type) => {
        if(this.onlyTotal ){
          if (stats[type + "_amount"] != undefined && (type == 'subscription_charged' || type == 'charged' || type == 'charged_without_var' || type == 'subscription_charged_without_var')) {
            total += parseFloat(stats[type + "_amount"]);


          }
        }else{
          if (stats[type + "_amount"] != undefined) {
            total += parseFloat(stats[type + "_amount"]);
          }
        }
      });

      if (this.getSumTotals(stats, this.statsType) > 0 ){
        percentage = (( total / this.getSumTotals(stats, this.statsType)) * 100).toFixed(2) //.toString();
      }
      if(this.hasPermissions('isAgencyManager')){
        return parseFloat(total*this.fee).toFixed(2)
      }

      if(percentage > 0){
        return  parseFloat(total).toFixed(0).toString() +  ' (' + percentage.toString() + ')';
      } else {
        return parseFloat(total).toFixed(0);
      }
    },
    getFullTotalQty(stats) {
      let total = 0;
      this.statsType.forEach((type) => {
        if (stats[type] != undefined) {
          total += parseFloat(stats[type]);
        }
      });
      return parseFloat(total).toFixed(0);
    },
    hasPermissions(perm){
      return this.$store.getters['authentication/hasPermissions'](perm)
    },
  },
};
</script>
<style>
</style>
